import React, { useContext, useEffect, useRef, useState } from "react";
import "./TaskDetailsModal.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import { LiaTrashAltSolid } from "react-icons/lia";
import { FiSend } from "react-icons/fi";
import { GrAttachment } from "react-icons/gr";
import { CgCloseO } from "react-icons/cg";
import {
  TbEdit,
  TbDeviceFloppy,
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarRightCollapse,
  TbChevronUp,
  TbChevronDown,
  TbPlayerPlay,
  TbPlayerStop,
} from "react-icons/tb";
import { useLanguage } from "../../../../LanguageProvider";
import HorizontalDivider from "../../../HorizontalDivider/HorizontalDivider";
import { IoDocumentTextOutline } from "react-icons/io5";
import Dropdown from "../../../Dropdown/Dropdown";
import DatePicker from "../../../DatePicker/DatePicker";
import TimePicker from "../../../TimePicker/TimePicker";
import { GeneralContext } from "../../../../GeneralProvider";
import { useToaster } from "../../../../ToasterProvider";
import AlertBox from "../../../AlertBox/AlertBox";
import TaskMemberDropdown from "../TaskMemberDropdown/TaskMemberDropdown";

const convertTimeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [timePart, meridian] = timeStr.split(" ");
  let [hours, minutes] = timePart.split(":").map(Number);

  if (meridian === "PM" && hours !== 12) {
    hours += 12;
  }
  if (meridian === "AM" && hours === 12) {
    hours = 0;
  }

  return hours * 60 + minutes;
};

export default function TaskDetailsModal({
  isOpen,
  onClose,
  task,
  projectAuthorization,
}) {
  const { language, getTranslation } = useLanguage();
  const {
    handleDeleteTask,
    handleUpdateTask,
    handleKronosCreateAndStart,
    handleKronosDiscard,
    handleKronosStop,
    activeKronos,
    triggerKronosRefresh,
    handleWriteComment,
    handleDeleteComment,
    handleUpdateComment,
    handleDeleteAttachment,
    handleDeleteCommentAttachment,
    handleAddTaskAttachment,
    handleAddCommentAttachment,
    userId,
    panels,
    subProjects,
    users,
    fetchMembers,
  } = useContext(GeneralContext);
  const { toastError, toastWarning } = useToaster();
  const modalRef = useRef();
  const menuRef = useRef();
  const menuContentRef = useRef();
  const commentInputRef = useRef(null);
  const isEditingAnyRef = useRef(false);
  const [_task, _setTask] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isEditingDates, setIsEditingDates] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [taskDescription, setTaskDescription] = useState("");
  const [taskTitle, setTaskTitle] = useState("");
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingSubTitle, setIsEditingSubTitle] = useState(false);
  const [isEditingSubProject, setIsEditingSubProject] = useState(false);
  const [taskSubProject, setTaskSubProject] = useState("");
  const [taskSubTitle, setTaskSubTitle] = useState("");
  const [taskStatus, setTaskStatus] = useState("3");
  const [todoList, setTodoList] = useState([]);
  const [tempTodoList, setTempTodoList] = useState([]);

  const [startDate, setStartDate] = useState("2024-01-01");
  const [startTime, setStartTime] = useState("09:00");
  const [endDate, setEndDate] = useState("2024-01-02");
  const [endTime, setEndTime] = useState("17:00");

  const [comment, setComment] = useState("");
  const [selectedComment, setSelectedComment] = useState(null);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");

  const [replyMention, setReplyMention] = useState("");
  const [commentAttachments, setCommentAttachments] = useState([]);
  const commentFileInputRef = useRef();

  const taskAttachmentFileInputRef = useRef();
  const [newTaskAttachments, setNewTaskAttachments] = useState([]);
  const [attachmentToDelete, setAttachmentToDelete] = useState(null);
  const [attachmentTypeToDelete, setAttachmentTypeToDelete] = useState(null);
  const [isAttachmentDeleteAlertOpen, setIsAttachmentDeleteAlertOpen] =
    useState(false);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);

  const attachments = _task?.attachments || [];

  useEffect(() => {
    fetchMembers();
  }, []);

  const activities = _task
    ? (() => {
      let acts = [];
      if (_task.logs) {
        acts = acts.concat(
          _task.logs.map((log) => ({
            ...log,
            type: "log",
            date: new Date(
              parseInt(log.createdDateTime, 10) * 1000
            ).toISOString(),
          }))
        );
      }
      if (_task.comments) {
        acts = acts.concat(
          _task.comments.map((comment) => ({
            ...comment,
            type: "comment",
            date: new Date(
              parseInt(comment.createdDateTime, 10) * 1000
            ).toISOString(),
          }))
        );
      }
      return acts.sort((a, b) => new Date(b.date) - new Date(a.date));
    })()
    : [];

  const cancelPreviousAndStart = async () => {
    try {
      const result = await handleKronosDiscard(
        activeKronos?.kronosId,
        activeKronos?.logId
      );
      if (result?.status) {
        handleCreateStartKronos(true);
        setIsAlertOpen(false);
      }
    } catch (error) {
      console.error("Error in cancelPreviousAndStart:", error);
    }
  };

  const stopKronos = async () => {
    try {
      await handleKronosStop(activeKronos?.logId);
    } catch (error) {
      console.error("Error in savePreviousAndStart:", error);
    }
  };

  const savePreviousAndStart = async () => {
    try {
      const result = await handleKronosStop(activeKronos?.logId);
      if (result?.status) {
        handleCreateStartKronos(true);
        setIsAlertOpen(false);
      }
    } catch (error) {
      console.error("Error in savePreviousAndStart:", error);
    }
  };

  const buttons = [
    {
      text: getTranslation("savePreviousAndStart"),
      onClick: savePreviousAndStart,
      styleType: "alert-confirm",
    },
    {
      text: getTranslation("cancelPreviousAndStart"),
      onClick: cancelPreviousAndStart,
      styleType: "alert-confirm",
    },
    {
      text: getTranslation("close"),
      onClick: () => setIsAlertOpen(false),
      styleType: "alert-cancel",
    },
  ];

  useEffect(() => {
    if (task) {
      setTaskTitle(task.taskTitle);
      setTaskDescription(task.taskDescription);
      setTaskSubTitle(task.subTitle);
      setTaskSubProject(
        task.subProject && task.subProject.subProjectId
          ? {
            value: task.subProject.subProjectId,
            label: task.subProject.title,
          }
          : { value: "", label: getTranslation("none") }
      );
      setTaskStatus(task.taskStatus || "3");
      setTodoList(task.taskTodo || []);
      const [taskStartDate, taskStartTime] = task.taskStart.split(" ");
      const [taskEndDate, taskEndTime] = task.taskEnd.split(" ");
      setStartDate(taskStartDate);
      setStartTime(taskStartTime.slice(0, 5));
      setEndDate(taskEndDate);
      setEndTime(taskEndTime.slice(0, 5));
      _setTask(task);
    }
  }, [task]);

  useEffect(() => {
    const updatedTask = panels
      ?.flatMap((panel) => panel.boards)
      ?.flatMap((board) => board.tasks)
      ?.find((t) => t?.taskId === task?.taskId);
    if (updatedTask) {
      _setTask(updatedTask);
    }
  }, [panels]);

  useEffect(() => {
    const updatedTask = panels
      ?.flatMap((panel) => panel.boards)
      ?.flatMap((board) => board.tasks)
      ?.find((t) => t?.taskId === task?.taskId);
    if (updatedTask) {
      _setTask(updatedTask);
    }
  }, []);

  const toggleAccordion = () => {
    setIsAccordionOpen((prev) => !prev);
  };

  const handleCommentFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const extension = file.name.split(".").pop();
        const title =
          file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
        setCommentAttachments((prev) => [
          ...prev,
          { file: base64String, extension, title },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleTaskAttachmentFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const extension = file.name.split(".").pop();
        const title =
          file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
        setNewTaskAttachments((prev) => [
          ...prev,
          { file: base64String, extension, title },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeCommentAttachment = (index) => {
    setCommentAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const removeTasktAttachment = (index) => {
    setNewTaskAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCommentUpdate = () => {
    if (!editingCommentText.trim()) return;
    const updateData = { comment: editingCommentText };
    handleUpdateComment(editingCommentId, updateData);
    setEditingCommentId(null);
    setEditingCommentText("");
  };

  // const handleSendComment = () => {
  //   if (!comment.trim()) return;
  //   if (selectedComment) {
  //     handleWriteComment(
  //       task?.taskId,
  //       comment,
  //       commentAttachments,
  //       selectedComment
  //     );
  //     setComment("");
  //     setCommentAttachments([]);
  //     setSelectedComment(null);
  //     setReplyMention("");
  //   } else {
  //     handleWriteComment(task?.taskId, comment, commentAttachments, null);
  //     setComment("");
  //     setCommentAttachments([]);
  //     setSelectedComment(null);
  //     setReplyMention("");
  //   }
  // };

  const handleSendComment = () => {
    if (!comment.trim() && commentAttachments?.length === 0) return;

    let sendText = comment;
    if (!comment.trim() && commentAttachments.length > 0) {
      sendText = "Attachment sent";
    }
    handleWriteComment(
      task?.taskId,
      sendText,
      commentAttachments,
      selectedComment
    );
    setComment("");
    setCommentAttachments([]);
    setSelectedComment(null);
    setReplyMention("");
  };

  const handleCommentDelete = (comment) => {
    handleDeleteComment(comment.taskCommentId);
  };

  const handleAttachmentDelete = (attachmentId) => {
    if (attachmentTypeToDelete === "comment") {
      handleDeleteCommentAttachment(attachmentId);
    } else {
      handleDeleteAttachment(attachmentId);
    }
    setAttachmentTypeToDelete(null);
  };

  const formatDate = (date) => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
    };
    return new Date(date).toLocaleDateString(language || "en-US", options);
  };

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleClickOutsideMenu = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMenu);
    };
  }, []);

  useEffect(() => {
    isEditingAnyRef.current =
      isEditingDates ||
      isEditingDescription ||
      isEditingStatus ||
      isEditingTitle ||
      isEditingSubTitle ||
      isEditingSubProject ||
      inputVisible;
  }, [
    isEditingDates,
    isEditingDescription,
    isEditingStatus,
    isEditingTitle,
    isEditingSubTitle,
    isEditingSubProject,
    inputVisible,
  ]);

  const handleClickOutside = (event) => {
    if (isOpen) {
      if (isEditingAnyRef.current) {
        return; // edit modundaysa hiçbir şey yapma
      }

      if (
        event.target.textContent &&
        event.target.textContent === getTranslation("deleteTask")
      ) {
        setIsDeleteAlertOpen(true);
        if (activeKronos && activeKronos.taskId === task.taskId) {
          stopKronos();
        }
      } else {
        if (
          modalRef.current &&
          !modalRef.current.contains(event.target) &&
          !(menuRef.current && menuRef.current.contains(event.target)) &&
          !(
            menuContentRef.current &&
            menuContentRef.current.contains(event.target)
          )
        ) {
          onClose();
          setIsEditingDates(false);
          setIsEditingDescription(false);
          setIsEditingStatus(false);
          setInputVisible(false);
          setInputValue("");
          setIsEditingTitle(false);
          setIsEditingSubTitle(false);
          setIsExpanded(false);
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const hasWritePermission =
    projectAuthorization?.authorizations === "all" ||
    projectAuthorization?.authorizations?.panels === "all" ||
    projectAuthorization?.authorizations?.panels?.some(
      (auth) => auth.id === task?.id && auth.authorization !== "read"
    );

  const handleEditTaskDescription = () => {
    if (isEditingDescription) {
      const updateData = {
        description: taskDescription,
      };
      handleUpdateTask(task.taskId, updateData);
    }
    setIsEditingDescription(!isEditingDescription);
  };

  const handleEditTitleAndSubTitle = () => {
    if (isEditingTitle && isEditingSubTitle) {
      // Kaydetme aşaması: title boş olamaz
      if (!taskTitle || taskTitle.trim() === "") {
        toastWarning(getTranslation("titleCantBeEmpty"));
        return; // Edit modundan çıkma, kullanıcı düzeltme yapsın
      }
      const updateData = {
        title: taskTitle.trim(),
        subTitle: taskSubTitle,
      };
      handleUpdateTask(task.taskId, updateData);
    }
    // Başarılıysa edit modunu kapat/aç
    setIsEditingTitle(!isEditingTitle);
    setIsEditingSubTitle(!isEditingSubTitle);
  };

  const handleEditSubProject = () => {
    setIsEditingSubProject(!isEditingSubProject);

    if (isEditingSubProject) {
      const updateData = {
        subProjectId: taskSubProject.value,
      };
      handleUpdateTask(task.taskId, updateData);
    }
  };

  const handleSubProjectChange = (e) => {
    const selectedOption = subProjectDropdownOptions.find(
      (option) => option.value === e.target.value
    );
    setTaskSubProject(selectedOption);
  };

  const handleEditStatus = () => {
    if (isEditingStatus) {
      const updateData = {
        status: taskStatus,
      };
      handleUpdateTask(task.taskId, updateData);
    }
    setIsEditingStatus(!isEditingStatus);
  };

  const formatDateTime = (date, time) => {
    try {
      const formattedDate = new Date(date);
      if (isNaN(formattedDate.getTime())) {
        throw new Error("Geçersiz tarih formatı");
      }
      const [hour, minute, period] = time.replace(":", " ").split(" ");
      let formattedHour = parseInt(hour, 10);
      if (period === "PM" && formattedHour !== 12) {
        formattedHour += 12;
      } else if (period === "AM" && formattedHour === 12) {
        formattedHour = 0;
      }
      formattedDate.setHours(formattedHour, parseInt(minute, 10), 0);
      const year = formattedDate.getFullYear();
      const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
      const day = String(formattedDate.getDate()).padStart(2, "0");
      const hours = String(formattedDate.getHours()).padStart(2, "0");
      const minutes = String(formattedDate.getMinutes()).padStart(2, "0");
      const seconds = "00";
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    } catch (error) {
      console.error("Tarih formatlama hatası:", error.message);
      return null;
    }
  };

  const toggleEditDates = () => {
    if (isEditingDates) {
      if (startDate === endDate && startTime && endTime) {
        const startTotalMinutes = convertTimeToMinutes(startTime);
        const endTotalMinutes = convertTimeToMinutes(endTime);

        if (endTotalMinutes < startTotalMinutes) {
          toastError(getTranslation("endTimeCannotBeBeforeStartTime"));
          return; // Fonksiyondan çık, tarih güncellemesini durdur
        }
      }

      const taskStart = formatDateTime(startDate, startTime);
      const taskEnd = formatDateTime(endDate, endTime);
      if (!taskStart || !taskEnd) {
        console.error("Geçersiz tarih veya saat değeri");
        return;
      }
      const updateData = {
        taskStart,
        taskEnd,
      };
      handleUpdateTask(task.taskId, updateData);
    }
    setIsEditingDates(!isEditingDates);
  };

  const handleStartDateChange = (value) => setStartDate(value);
  const handleStartTimeChange = (value) => setStartTime(value);
  const handleEndDateChange = (value) => setEndDate(value);
  const handleEndTimeChange = (value) => setEndTime(value);

  const toggleCheckbox = (selectedItem) => {
    const updatedList = todoList.map((item) =>
      item.text === selectedItem.text
        ? { ...item, checked: !item.checked }
        : item
    );
    setTodoList(updatedList);
    const updateData = { taskTodo: updatedList };
    handleUpdateTask(task.taskId, updateData);
  };

  const handleAddTodo = () => {
    if (inputValue) {
      setTempTodoList([
        ...tempTodoList,
        { text: inputValue.replaceAll('"', "''"), checked: false },
      ]);
      setInputValue("");
    }
  };

  const handleSaveTodoList = () => {
    const updateData = { taskTodo: tempTodoList };
    handleUpdateTask(task.taskId, updateData);
    setTodoList(tempTodoList);
    setTempTodoList([]);
    setInputVisible(false);
  };

  const updateTempTodo = (index, newText) => {
    const updatedList = [...tempTodoList];
    updatedList[index] = { ...updatedList[index], text: newText };
    setTempTodoList(updatedList);
  };

  const handleRemoveTempTodo = (item) => {
    const newTempTodoList = tempTodoList.filter((x) => x !== item);
    setTempTodoList(newTempTodoList);
  };

  const deleteTask = () => {
    handleDeleteTask(task.taskId);
    onClose();
    setIsEditingDates(false);
    setIsEditingDescription(false);
    setIsEditingStatus(false);
    setInputVisible(false);
    setInputValue("");
    setIsEditingTitle(false);
    setIsEditingSubTitle(false);
    setIsExpanded(false);
    setIsDeleteAlertOpen(false);
  };

  const handleCreateStartKronos = async (bypassCheck = false) => {
    if (!bypassCheck && activeKronos) {
      setIsAlertOpen(true);
      return;
    }
    const kronosData = { title: task.taskTitle, taskId: task.taskId };
    try {
      const result = await handleKronosCreateAndStart(kronosData);
      if (result.status) {
        triggerKronosRefresh();
      } else {
        toastError(getTranslation("somethingWentWrong"));
      }
    } catch (error) {
      toastError(getTranslation("somethingWentWrong"));
    }
  };

  const renderStatusChip = (status) => {
    const statusStyles = {
      1: {
        backgroundColor: "#d4edda",
        color: "#155724",
        text: getTranslation("completed"),
      },
      2: {
        backgroundColor: "#aa2f26",
        color: "#fff",
        text: getTranslation("cancelled"),
      },
      3: {
        backgroundColor: "#fff3cd",
        color: "#856404",
        text: getTranslation("pending"),
      },
      4: {
        backgroundColor: "#fff3cd",
        color: "#856404",
        text: getTranslation("inProgress"),
      },
    };
    const { backgroundColor, color, text } = statusStyles[status];
    return (
      <span
        style={{
          padding: "5px 10px",
          backgroundColor,
          color,
          borderRadius: "15px",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        {getTranslation(text)}
      </span>
    );
  };

  useEffect(() => {
    if (task?.taskId !== _task?.taskId) {
      _setTask(task);
    }
  }, [task]);

  function getFirstAndLastInitials(sentence) {
    const words = sentence
      .trim()
      .split(/\s+/)
      .filter((w) => w.length > 0);
    if (words.length === 0) return "";
    const firstInitial = words[0][0];
    const lastInitial = words[words.length - 1][0];
    return (firstInitial + lastInitial).toUpperCase();
  }

  const statusList = [
    { value: 1, label: getTranslation("completed") },
    { value: 2, label: getTranslation("cancelled") },
    { value: 3, label: getTranslation("pending") },
    { value: 4, label: getTranslation("inProgress") },
  ];

  const toggleExpansion = () => setIsExpanded(!isExpanded);

  if (!isOpen) return null;

  const formatDateTimeDisplay = (isoString) => {
    const date = new Date(isoString);
    const month = date.toLocaleString(language, { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();
    const minute = date.getMinutes();
    const minuteFormatted = minute < 10 ? "0" + minute : minute;
    return `${month} ${day}, ${year}, ${date.getHours()}:${minuteFormatted}`;
  };

  const subProjectDropdownOptions = [
    { value: "", label: getTranslation("none") },
    ...(subProjects && Array.isArray(subProjects) ? subProjects : []),
  ];

  return (
    <div
      className={`task-detail-modal-main-container ${isExpanded ? "expanded" : ""
        }`}
      ref={modalRef}
    >
      <div className="task-detail-modal-header-icons">
        {isExpanded ? (
          <TbLayoutSidebarRightCollapse
            onClick={toggleExpansion}
            className="task-detail-modal-expand-icon"
            size={24}
          />
        ) : (
          <TbLayoutSidebarLeftCollapse
            onClick={toggleExpansion}
            className="task-detail-modal-expand-icon"
            size={24}
          />
        )}
        {hasWritePermission && (
          <BsThreeDotsVertical
            onClick={handleMenuToggle}
            className="task-detail-modal-options-button"
            size={24}
            ref={menuRef}
          />
        )}
      </div>

      {!isExpanded && (
        <>
          {menuOpen && (
            <div
              className="task-detail-modal-options-menu"
              ref={menuContentRef}
            >
              <div
                className="task-detail-modal-options-menu-item"
                onClick={(e) => deleteTask(e)}
              >
                {getTranslation("deleteTask")}
              </div>
            </div>
          )}

          <div
            style={{ marginBottom: task?.subProject ? 10 : 0 }}
            className="task-detail-modal-title-holder"
          >
            <span
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {isEditingTitle ? (
                <>
                  <input
                    className="task-detail-modal-subtitle-input"
                    value={taskTitle}
                    onChange={(e) => setTaskTitle(e.target.value)}
                    placeholder={getTranslation("enterTitle")}
                  />
                  <input
                    className="task-detail-modal-subtitle-input"
                    value={taskSubTitle}
                    onChange={(e) => setTaskSubTitle(e.target.value)}
                    placeholder={getTranslation("enterSubtitle")}
                  />
                </>
              ) : (
                <span
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100%",
                    alignItems: "center",
                    gap: "3px",
                  }}
                >
                  <span title={taskTitle} className="task-detail-modal-title">
                    {taskTitle}
                  </span>
                  <span style={{ fontSize: "14px" }}>
                    {taskSubTitle && " - " + taskSubTitle}
                  </span>
                </span>
              )}
            </span>
            <span>
              {isEditingSubTitle ? (
                <TbDeviceFloppy
                  size={18}
                  className="task-detail-modal-icon"
                  onClick={handleEditTitleAndSubTitle}
                />
              ) : (
                hasWritePermission && (
                  <TbEdit
                    size={18}
                    className="task-detail-modal-icon"
                    onClick={handleEditTitleAndSubTitle}
                  />
                )
              )}
            </span>
          </div>

          <div
            style={{ marginBottom: task?.subProject ? 10 : 0 }}
            className="task-detail-modal-title-holder"
          >
            {isEditingSubProject ? (
              <>
                <Dropdown
                  placeholder={getTranslation("selectProject")}
                  options={subProjectDropdownOptions}
                  onChange={handleSubProjectChange}
                  value={taskSubProject?.value || ""}
                />
                <span>
                  {isEditingSubProject ? (
                    <TbDeviceFloppy
                      size={18}
                      className="task-detail-modal-icon"
                      onClick={handleEditSubProject}
                    />
                  ) : (
                    hasWritePermission && (
                      <TbEdit
                        size={18}
                        className="task-detail-modal-icon"
                        onClick={handleEditSubProject}
                      />
                    )
                  )}
                </span>
              </>
            ) : (
              <>
                <span className="task-detail-modal-sub-project">
                  {taskSubProject?.label || getTranslation("none")}
                </span>
                <span>
                  {isEditingSubProject ? (
                    <TbDeviceFloppy
                      size={18}
                      className="task-detail-modal-icon"
                      onClick={handleEditSubProject}
                    />
                  ) : (
                    hasWritePermission && (
                      <TbEdit
                        size={18}
                        className="task-detail-modal-icon"
                        onClick={handleEditSubProject}
                      />
                    )
                  )}
                </span>
              </>
            )}
          </div>

          <div className="task-detail-modal-dates">
            {`${formatDate(startDate)} ${startTime} - ${formatDate(
              endDate
            )} ${endTime}`}
            {hasWritePermission && (
              <span onClick={toggleEditDates}>
                {isEditingDates ? (
                  <TbDeviceFloppy
                    className="task-detail-modal-icon"
                    size={18}
                  />
                ) : (
                  <TbEdit className="task-detail-modal-icon" size={18} />
                )}
              </span>
            )}
          </div>

          {isEditingDates && (
            <div style={{ marginTop: "15px" }}>
              <div
                style={{ display: "flex", gap: "10px", flexDirection: "row" }}
              >
                <DatePicker
                  style={{ width: "50%" }}
                  buttonStyle={{ width: "100%" }}
                  selectedDate={startDate}
                  onDateSelect={handleStartDateChange}
                  toggleLabel={getTranslation("startDate")}
                  initialDate={startDate}
                />
                <TimePicker
                  align={"right"}
                  style={{ width: "50%" }}
                  buttonStyle={{ width: "100%" }}
                  selectedTime={startTime}
                  onTimeSelect={handleStartTimeChange}
                  toggleLabel={getTranslation("startTime")}
                  initialTime={startTime}
                  quarterIntervals
                />
              </div>
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <DatePicker
                  style={{ width: "50%" }}
                  buttonStyle={{ width: "100%" }}
                  selectedDate={endDate}
                  resetDate={startDate}
                  minDate={startDate}
                  onDateSelect={handleEndDateChange}
                  toggleLabel={getTranslation("endDate")}
                  initialDate={endDate}
                />
                <TimePicker
                  align={"right"}
                  style={{ width: "50%" }}
                  buttonStyle={{ width: "100%" }}
                  selectedTime={endTime}
                  onTimeSelect={handleEndTimeChange}
                  toggleLabel={getTranslation("endTime")}
                  initialTime={endTime}
                  quarterIntervals
                />
              </div>
            </div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="task-detail-modal-status">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <span className="task-detail-modal-area-title">
                  {getTranslation("status")}
                </span>
                {isEditingStatus ? (
                  <Dropdown
                    style={{ width: "130px" }}
                    options={statusList}
                    onChange={(e) => setTaskStatus(e.target.value)}
                    value={taskStatus}
                  />
                ) : (
                  <div>{renderStatusChip(taskStatus)}</div>
                )}
              </div>
              <span onClick={handleEditStatus}>
                {isEditingStatus ? (
                  <TbDeviceFloppy
                    className="task-detail-modal-icon"
                    size={18}
                  />
                ) : (
                  <TbEdit className="task-detail-modal-icon" size={18} />
                )}
              </span>
            </div>

            <div className="task-detail-modal-kronos-container">
              {activeKronos && activeKronos.taskId === task.taskId ? (
                <>
                  <span className="task-detail-modal-start-kronos">
                    {getTranslation("stopKronos")}
                  </span>
                  <span
                    onClick={stopKronos}
                    className="task-detail-modal-play-button"
                  >
                    <TbPlayerStop />
                  </span>
                </>
              ) : (
                <>
                  <span className="task-detail-modal-start-kronos">
                    {getTranslation("startKronos")}
                  </span>
                  <span
                    onClick={() => handleCreateStartKronos(false)}
                    className="task-detail-modal-play-button"
                  >
                    <TbPlayerPlay />
                  </span>
                </>
              )}
            </div>
          </div>

          <HorizontalDivider />

          <div
            className="task-detail-modal-description"
            style={{
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "100%",
              display: "flex",
            }}
          >
            <span className="task-detail-modal-area-title">
              {getTranslation("myCollaborators")}
            </span>

            <span style={{ width: "100%" }}>
              <TaskMemberDropdown
                users={users}
                task={_task}
                inTaskUsers={
                  _task?.members
                    ? _task?.members?.map((user) => ({
                      ...user,
                      userID: user.id,
                    }))
                    : []
                }
              />
            </span>
          </div>

          <div className="task-detail-modal-description">
            <span className="task-detail-modal-area-title">
              {getTranslation("description")}
            </span>
            {hasWritePermission && (
              <span onClick={handleEditTaskDescription}>
                {isEditingDescription ? (
                  <TbDeviceFloppy
                    className="task-detail-modal-icon"
                    size={18}
                  />
                ) : (
                  <TbEdit className="task-detail-modal-icon" size={18} />
                )}
              </span>
            )}
          </div>

          {isEditingDescription ? (
            <div className="task-detail-modal-content">
              <IoDocumentTextOutline
                size={20}
                style={{
                  width: "25px",
                  alignSelf: "flex-start",
                  marginTop: "10px",
                }}
              />
              <textarea
                className="task-detail-modal-textarea"
                placeholder={getTranslation("description")}
                value={taskDescription}
                rows={6}
                onChange={(e) => setTaskDescription(e.target.value)}
              ></textarea>
            </div>
          ) : (
            <div className="task-detail-modal-description-holder">
              <p>
                {taskDescription
                  ? taskDescription
                  : getTranslation("noDescription")}
              </p>
            </div>
          )}

          <div style={{ width: "100%", marginBottom: 20 }}>
            <div className="task-detail-modal-todo-container">
              <span className="task-detail-modal-area-title">
                {getTranslation("toDoList")}
              </span>
              {!inputVisible ? (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setInputVisible(true);
                    setTempTodoList([...todoList]);
                  }}
                >
                  <TbEdit className="task-detail-modal-icon" size={18} />
                </span>
              ) : (
                <span onClick={handleSaveTodoList}>
                  <TbDeviceFloppy
                    className="task-detail-modal-icon"
                    size={18}
                  />
                </span>
              )}
            </div>
            {inputVisible && (
              <>
                <div className="task-detail-todo-input-container">
                  <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder={getTranslation("enterToDo")}
                    className="task-detail-todo-input"
                  />
                  <button
                    className="task-detail-todo-add-button"
                    onClick={handleAddTodo}
                  >
                    {getTranslation("add")}
                  </button>
                </div>
                {tempTodoList?.map((item, index) => (
                  <div key={index} className="task-detail-todo-box">
                    <input
                      type="text"
                      className="task-detail-todo-input"
                      value={item.text}
                      onChange={(e) => updateTempTodo(index, e.target.value)}
                      style={{
                        width: "85%",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "inherit",
                      }}
                    />
                    <LiaTrashAltSolid
                      size={23}
                      onClick={() => handleRemoveTempTodo(item)}
                      style={{ cursor: "var(--pointer)" }}
                    />
                  </div>
                ))}
              </>
            )}
            {!inputVisible &&
              todoList?.map((item, index) => (
                <div
                  key={index}
                  className="task-detail-todo-box"
                  style={{ justifyContent: "flex-start", gap: "15px" }}
                  onClick={() => toggleCheckbox(item)}
                >
                  <input type="checkbox" checked={item.checked} />
                  <span>{item.text}</span>
                </div>
              ))}
          </div>

          <div className="task-detail-modal-description-expanded">
            <span className="task-detail-modal-area-title">
              {getTranslation("attachments")} ({attachments?.length}){" "}
              <GrAttachment
                className="task-detail-modal-icon"
                style={{ marginLeft: 10 }}
                size={14}
                onClick={() => {
                  if (taskAttachmentFileInputRef.current) {
                    taskAttachmentFileInputRef.current.click();
                  } else {
                    console.error("File input not available");
                  }
                }}
              />
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.pdf,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip,.mp4,.mp3,.wav,.json,.csv,.dat"
                ref={taskAttachmentFileInputRef}
                style={{ display: "none" }}
                multiple
                onChange={handleTaskAttachmentFileChange}
              />
              {newTaskAttachments.length > 0 && (
                <TbDeviceFloppy
                  className="task-detail-modal-icon"
                  style={{ marginLeft: 10 }}
                  size={18}
                  onClick={() => {
                    handleAddTaskAttachment(task.taskId, newTaskAttachments);
                    setNewTaskAttachments([]);
                  }}
                />
              )}
            </span>

            <span onClick={toggleAccordion}>
              {isAccordionOpen ? (
                <TbChevronUp className="task-detail-modal-icon" size={18} />
              ) : (
                <TbChevronDown className="task-detail-modal-icon" size={18} />
              )}
            </span>
          </div>

          {newTaskAttachments.length > 0 && (
            <div style={{ display: "flex", gap: "8px", padding: "8px 0" }}>
              {newTaskAttachments.map((file, index) => (
                <div
                  key={index}
                  className="task-detail-modal-added-attachment-chip"
                >
                  <span className="task-detail-modal-added-attachment-chip-title">
                    {file.title}
                  </span>
                  <CgCloseO
                    onClick={() => removeTasktAttachment(index)}
                    style={{
                      cursor: "var(--pointer)",
                      minWidth: "14px",
                      minHeight: "14px",
                      width: "14px",
                      height: "14px",
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          {isAccordionOpen && attachments.length > 0 && (
            <div className="accordion-content">
              {attachments.map((attachment) => (
                <div
                  key={attachment.attachmentId || attachment.id}
                  className="task-detail-attachment-holder"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    onClick={() => window.open(attachment.attachment, "_blank")}
                    style={{ display: "flex", flex: 1, cursor: "pointer" }}
                  >
                    <div className="task-detail-attachment-box" />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "8px",
                      }}
                    >
                      <span className="task-detail-attachment-title">
                        {attachment.title}
                      </span>
                      <span className="task-detail-attachment-size">
                        {attachment.createdDateTime
                          ? new Date(
                            parseInt(attachment.createdDateTime, 10) * 1000
                          ).toLocaleDateString(language || "en-US", {
                            weekday: "long",
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })
                          : ""}
                      </span>
                    </div>
                  </div>
                  <CgCloseO
                    size={16}
                    className="task-detail-modal-icon"
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setAttachmentToDelete(
                        attachment.attachmentId || attachment.id
                      );
                      setAttachmentTypeToDelete("task");
                      setIsAttachmentDeleteAlertOpen(true);
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          <div className="task-detail-comments-container">
            <span
              className="task-detail-modal-area-title"
              style={{ marginBottom: "15px" }}
            >
              {getTranslation("activity")}
            </span>
            {replyMention && (
              <div className="reply-mention-container">
                <span className="reply-mention-text">
                  {getTranslation("respondingTo")}:
                </span>

                <div className="reply-mention-bubble">
                  <span className="reply-mention-bubble-text">
                    {replyMention}
                  </span>
                  <CgCloseO
                    size={16}
                    className="reply-mention-bubble-cancel"
                    onClick={() => {
                      setReplyMention("");
                      setSelectedComment(null);
                    }}
                  />
                </div>
              </div>
            )}
            <div className="task-detail-comment-holder">
              <input
                ref={commentInputRef}
                className="task-detail-modal-subtitle-input"
                style={{ width: "100%" }}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder={getTranslation("writeAComment")}
              />

              <FiSend
                onClick={handleSendComment}
                className="task-comment-send-icon"
                size={20}
              />
              <GrAttachment
                onClick={() => commentFileInputRef.current.click()}
                className="task-comment-send-icon"
                size={20}
              />
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.pdf,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip,.mp4,.mp3,.wav,.json,.csv,.dat"
                ref={commentFileInputRef}
                style={{ display: "none" }}
                multiple
                onChange={handleCommentFileChange}
              />
            </div>

            {commentAttachments?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "8px",
                  padding: "8px 0",
                  width: "100%",
                  marginBottom: 20,
                }}
              >
                {commentAttachments.map((file, index) => (
                  <div
                    className="task-detail-modal-added-attachment-chip"
                    key={index}
                  >
                    <span className="task-detail-modal-added-attachment-chip-title">
                      {file.title}
                    </span>
                    <CgCloseO
                      onClick={() => removeCommentAttachment(index)}
                      style={{
                        cursor: "var(--pointer)",
                        minWidth: "14px",
                        minHeight: "14px",
                        width: "14px",
                        height: "14px",
                      }}
                    />
                  </div>
                ))}
              </div>
            )}

            {activities.map((item) => {
              if (item.type === "log") {
                // Log için data_json içindeki createdBy'dan ad soyad alıyoruz.
                const createdBy = item.dataJson?.createdBy;
                return (
                  <div
                    key={`log-${item.logId || item.id}`}
                    className="task-detail-comment-holder"
                  >
                    {createdBy.userAvatar ? (
                      <img
                        src={createdBy.userAvatar}
                        className="social-hive-chat__avatar"
                      />
                    ) : (
                      <div className="social-hive-chat__avatar">
                        {getFirstAndLastInitials(
                          createdBy.name + " " + createdBy.lastname
                        )}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        marginTop: "-5px",
                      }}
                    >
                      <span style={{ width: "100%" }}>
                        <span className="task-detail-user-name">
                          {createdBy
                            ? `${createdBy.name} ${createdBy.lastname}`
                            : item.createdBy}
                        </span>
                        <span className="task-detail-comment-date">
                          {item.log}
                        </span>
                      </span>
                      <span className="task-detail-comment-date">
                        {formatDateTimeDisplay(item.date)}
                      </span>
                    </div>
                  </div>
                );
              } else if (item.type === "comment") {
                return (
                  <div
                    key={`comment-${item.taskCommentId || item.id}`}
                    style={{ width: "100%" }}
                  >
                    <div className="task-detail-comment-holder">
                      {item.userAvatar ? (
                        <img
                          src={item.userAvatar}
                          className="social-hive-chat__avatar"
                        />
                      ) : (
                        <div className="social-hive-chat__avatar">
                          {getFirstAndLastInitials(
                            item.name + " " + item.lastname
                          )}
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          alignItems: "flex-start",
                          justifyContent: "flex-start",
                          marginTop: "-5px",
                        }}
                      >
                        <span style={{ width: "100%" }}>
                          <span className="task-detail-user-name">
                            {item.name} {item.lastname}
                          </span>
                          <span className="task-detail-comment-date">
                            {formatDateTimeDisplay(item.date)}
                          </span>
                        </span>
                        {editingCommentId ===
                          (item.taskCommentId || item.id) ? (
                          <input
                            type="text"
                            className="task-detail-comment-box"
                            value={editingCommentText}
                            onChange={(e) =>
                              setEditingCommentText(e.target.value)
                            }
                          />
                        ) : (
                          <span className="task-detail-comment-box">
                            {item.comment}
                          </span>
                        )}

                        {/* Eğer yorumun attachments varsa, onları göster */}

                        {item.attachments && item.attachments.length > 0 && (
                          <div className="task-detail-comment-attachments">
                            {item.attachments.map((att, idx) => (
                              <div
                                key={att.attachmentId || idx}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  className="task-detail-attachment-holder"
                                  onClick={() =>
                                    window.open(att.attachment, "_blank")
                                  }
                                  style={{
                                    display: "flex",
                                    flex: 1,
                                    cursor: "var(--pointer)",
                                  }}
                                >
                                  <div className="task-detail-attachment-box" />
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <span className="task-detail-attachment-title">
                                      {att.title}
                                    </span>
                                    <span className="task-detail-attachment-size">
                                      {att.createdDateTime
                                        ? new Date(
                                          parseInt(att.createdDateTime, 10) *
                                          1000
                                        ).toLocaleDateString(
                                          language || "en-US",
                                          {
                                            weekday: "long",
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                          }
                                        )
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                {item.createdBy === userId && (
                                  <CgCloseO
                                    size={16}
                                    className="task-detail-modal-icon"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAttachmentToDelete(
                                        att.attachmentId || att.id
                                      );
                                      setAttachmentTypeToDelete("comment");
                                      setIsAttachmentDeleteAlertOpen(true);
                                    }}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        <div className="task-detail-comment-footer">
                          <span
                            onClick={() => {
                              setSelectedComment(item.taskCommentId);
                              setReplyMention(`@${item.name}`);
                              commentInputRef.current.focus();
                            }}
                            className="task-detail-reply-button"
                          >
                            {getTranslation("reply")}
                          </span>
                          {item?.createdBy === userId && (
                            <>
                              {editingCommentId ===
                                (item.taskCommentId || item.id) ? (
                                <span
                                  onClick={handleCommentUpdate}
                                  className="task-detail-reply-button"
                                >
                                  {getTranslation("save")}
                                </span>
                              ) : (
                                <span
                                  onClick={() => {
                                    setEditingCommentId(
                                      item.taskCommentId || item.id
                                    );
                                    setEditingCommentText(item.comment);
                                  }}
                                  className="task-detail-reply-button"
                                >
                                  {getTranslation("edit")}
                                </span>
                              )}
                              <span
                                onClick={() => handleCommentDelete(item)}
                                className="task-detail-reply-button"
                              >
                                {getTranslation("delete")}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {item.replies &&
                      item.replies.map((reply) => (
                        <div
                          key={`reply-${reply.taskCommentId || reply.id}`}
                          className="task-detail-comment-reply-holder"
                        >
                          {reply.userAvatar ? (
                            <img
                              src={reply.userAvatar}
                              className="social-hive-chat__avatar"
                            />
                          ) : (
                            <div className="social-hive-chat__avatar">
                              {getFirstAndLastInitials(
                                reply.name + " " + reply.lastname
                              )}
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              marginTop: "-5px",
                            }}
                          >
                            <span style={{ width: "100%" }}>
                              <span className="task-detail-user-name">
                                {reply.name} {reply.lastname}
                              </span>
                              <span className="task-detail-comment-date">
                                {formatDateTimeDisplay(
                                  parseInt(reply.createdDateTime, 10) * 1000
                                )}
                              </span>
                            </span>
                            {editingCommentId ===
                              (reply.taskCommentId || reply.id) ? (
                              <input
                                type="text"
                                className="task-detail-comment-box"
                                value={editingCommentText}
                                onChange={(e) =>
                                  setEditingCommentText(e.target.value)
                                }
                              />
                            ) : (
                              <span className="task-detail-comment-box">
                                {reply.comment}
                              </span>
                            )}

                            {/* Reply attachments */}
                            {reply.attachments &&
                              reply.attachments.length > 0 && (
                                <div className="task-detail-comment-attachments">
                                  {reply.attachments.map((att, idx) => (
                                    <div
                                      key={att.attachmentId || idx}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        className="task-detail-attachment-holder"
                                        onClick={() =>
                                          window.open(att.attachment, "_blank")
                                        }
                                        style={{
                                          display: "flex",
                                          flex: 1,
                                          cursor: "var(--pointer)",
                                        }}
                                      >
                                        <div className="task-detail-attachment-box" />
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <span className="task-detail-attachment-title">
                                            {att.title}
                                          </span>
                                          <span className="task-detail-attachment-size">
                                            {att.createdDateTime
                                              ? new Date(
                                                parseInt(
                                                  att.createdDateTime,
                                                  10
                                                ) * 1000
                                              ).toLocaleDateString(
                                                language || "en-US",
                                                {
                                                  weekday: "long",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                }
                                              )
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                      {reply.createdBy === userId && (
                                        <CgCloseO
                                          size={16}
                                          className="task-detail-modal-icon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setAttachmentToDelete(
                                              att.attachmentId || att.id
                                            );
                                            setAttachmentTypeToDelete(
                                              "comment"
                                            );
                                            setIsAttachmentDeleteAlertOpen(
                                              true
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}

                            <div className="task-detail-comment-footer">
                              <span
                                onClick={() => {
                                  setSelectedComment(item.taskCommentId);
                                  setReplyMention(`@${reply.name}`);
                                  commentInputRef.current.focus();
                                }}
                                className="task-detail-reply-button"
                              >
                                {getTranslation("reply")}
                              </span>
                              {reply?.createdBy === userId && (
                                <>
                                  {editingCommentId ===
                                    (reply.taskCommentId || reply.id) ? (
                                    <span
                                      onClick={handleCommentUpdate}
                                      className="task-detail-reply-button"
                                    >
                                      {getTranslation("save")}
                                    </span>
                                  ) : (
                                    <span
                                      onClick={() => {
                                        setEditingCommentId(
                                          reply.taskCommentId || reply.id
                                        );
                                        setEditingCommentText(reply.comment);
                                      }}
                                      className="task-detail-reply-button"
                                    >
                                      {getTranslation("edit")}
                                    </span>
                                  )}
                                  <span
                                    onClick={() => handleCommentDelete(reply)}
                                    className="task-detail-reply-button"
                                  >
                                    {getTranslation("delete")}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                );
              }
              return null;
            })}
          </div>
        </>
      )}

      {isExpanded && (
        <>
          {menuOpen && (
            <div
              className="task-detail-modal-options-menu"
              ref={menuContentRef}
            >
              <div
                className="task-detail-modal-options-menu-item"
                onClick={(e) => deleteTask(e)}
              >
                {getTranslation("deleteTask")}
              </div>
            </div>
          )}

          <div className="task-detail-modal-title-holder-expanded">
            <span
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
                flexWrap: "wrap",
                flex: 3,
              }}
            >
              {isEditingTitle ? (
                <>
                  <input
                    className="task-detail-modal-subtitle-input"
                    value={taskTitle}
                    onChange={(e) => setTaskTitle(e.target.value)}
                    placeholder={getTranslation("enterTitle")}
                  />
                  <input
                    className="task-detail-modal-subtitle-input"
                    value={taskSubTitle}
                    onChange={(e) => setTaskSubTitle(e.target.value)}
                    placeholder={getTranslation("enterSubtitle")}
                  />
                </>
              ) : (
                <>
                  <span title={taskTitle} className="task-detail-modal-title">
                    {taskTitle}
                  </span>
                  <span style={{ fontSize: "14px" }}>
                    {taskSubTitle && " - " + taskSubTitle}
                  </span>
                </>
              )}
              <span style={{ marginTop: "4px", marginLeft: "10px" }}>
                {isEditingSubTitle ? (
                  <TbDeviceFloppy
                    size={18}
                    className="task-detail-modal-icon"
                    onClick={handleEditTitleAndSubTitle}
                  />
                ) : (
                  hasWritePermission && (
                    <TbEdit
                      size={18}
                      className="task-detail-modal-icon"
                      onClick={handleEditTitleAndSubTitle}
                    />
                  )
                )}
              </span>
            </span>

            <div
              className="task-detail-modal-status-expanded"
              style={{ flex: 2 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <span className="task-detail-modal-area-title">
                  {getTranslation("status")}
                </span>
                {isEditingStatus ? (
                  <Dropdown
                    options={statusList}
                    onChange={(e) => setTaskStatus(e.target.value)}
                    value={taskStatus}
                  />
                ) : (
                  <div>{renderStatusChip(taskStatus)}</div>
                )}
              </div>
              <span
                onClick={handleEditStatus}
                style={{ marginLeft: "9px", marginTop: "3px" }}
              >
                {isEditingStatus ? (
                  <TbDeviceFloppy
                    className="task-detail-modal-icon"
                    size={18}
                  />
                ) : (
                  <TbEdit className="task-detail-modal-icon" size={18} />
                )}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                flex: 1,
                justifyContent: "flex-end",
              }}
            >
              <span className="task-detail-modal-area-title">
                {getTranslation("actions")}
              </span>
              <span className="task-detail-modal-actions-expanded">
                Webhook
              </span>
            </div>
          </div>

          <div
            style={{
              marginBottom: task?.subProject ? "20px" : 0,
              justifyContent: "flex-start",
              gap: "15px",
            }}
            className="task-detail-modal-title-holder-expanded"
          >
            {isEditingSubProject ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <Dropdown
                  placeholder={getTranslation("selectProject")}
                  options={subProjectDropdownOptions}
                  onChange={handleSubProjectChange}
                  value={taskSubProject?.value || ""}
                />
                <span>
                  {isEditingSubProject ? (
                    <TbDeviceFloppy
                      size={18}
                      className="task-detail-modal-icon"
                      onClick={handleEditSubProject}
                    />
                  ) : (
                    hasWritePermission && (
                      <TbEdit
                        size={18}
                        className="task-detail-modal-icon"
                        onClick={handleEditSubProject}
                      />
                    )
                  )}
                </span>
              </div>
            ) : (
              <>
                <span className="task-detail-modal-sub-project">
                  {taskSubProject?.label || getTranslation("none")}
                </span>
                <span>
                  {isEditingSubProject ? (
                    <TbDeviceFloppy
                      size={18}
                      className="task-detail-modal-icon"
                      onClick={handleEditSubProject}
                    />
                  ) : (
                    hasWritePermission && (
                      <TbEdit
                        size={18}
                        className="task-detail-modal-icon"
                        onClick={handleEditSubProject}
                      />
                    )
                  )}
                </span>
              </>
            )}
          </div>

          <div className="task-detail-modal-dates-expanded">
            {`${formatDate(startDate)} ${startTime} - ${formatDate(
              endDate
            )} ${endTime}`}
          </div>

          <HorizontalDivider
            secondary
            style={{ width: "100%", marginTop: "10px" }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ width: "60%" }}>
              <div className="task-detail-modal-description-expanded">
                <span className="task-detail-modal-area-title">
                  {getTranslation("description")}
                </span>
                {hasWritePermission && (
                  <span onClick={handleEditTaskDescription}>
                    {isEditingDescription ? (
                      <TbDeviceFloppy
                        className="task-detail-modal-icon"
                        size={18}
                      />
                    ) : (
                      <TbEdit className="task-detail-modal-icon" size={18} />
                    )}
                  </span>
                )}
              </div>
              {isEditingDescription ? (
                <div className="task-detail-modal-content">
                  <IoDocumentTextOutline
                    size={20}
                    style={{
                      width: "25px",
                      alignSelf: "flex-start",
                      marginTop: "10px",
                    }}
                  />
                  <textarea
                    className="task-detail-modal-textarea"
                    placeholder={getTranslation("description")}
                    value={taskDescription}
                    rows={6}
                    onChange={(e) => setTaskDescription(e.target.value)}
                  ></textarea>
                </div>
              ) : (
                <div
                  className="task-detail-modal-description-holder"
                  style={{ height: "128px" }}
                >
                  <p>
                    {taskDescription
                      ? taskDescription
                      : getTranslation("noDescription")}
                  </p>
                </div>
              )}

              <div className="task-detail-modal-description-expanded">
                <span className="task-detail-modal-area-title">
                  {getTranslation("attachments")} ({attachments.length}){" "}
                  <GrAttachment
                    className="task-detail-modal-icon"
                    style={{ marginLeft: 10 }}
                    size={14}
                    onClick={() => {
                      if (taskAttachmentFileInputRef.current) {
                        taskAttachmentFileInputRef.current.click();
                      } else {
                        console.error("File input not available");
                      }
                    }}
                  />
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg,.gif,.pdf,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip,.mp4,.mp3,.wav,.json,.csv,.dat"
                    ref={taskAttachmentFileInputRef}
                    style={{ display: "none" }}
                    multiple
                    onChange={handleTaskAttachmentFileChange}
                  />
                </span>
                <span onClick={toggleAccordion}>
                  {isAccordionOpen ? (
                    <TbChevronUp className="task-detail-modal-icon" size={18} />
                  ) : (
                    <TbChevronDown
                      className="task-detail-modal-icon"
                      size={18}
                    />
                  )}
                </span>
              </div>

              {isAccordionOpen && attachments.length > 0 && (
                <div className="accordion-content">
                  {attachments.map((attachment) => (
                    <div
                      key={attachment.attachmentId || attachment.id}
                      className="task-detail-attachment-holder"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        onClick={() =>
                          window.open(attachment.attachment, "_blank")
                        }
                        style={{ display: "flex", flex: 1, cursor: "pointer" }}
                      >
                        <div className="task-detail-attachment-box" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "8px",
                          }}
                        >
                          <span className="task-detail-attachment-title">
                            {attachment.title}
                          </span>
                          <span className="task-detail-attachment-size">
                            {attachment.createdDateTime
                              ? new Date(
                                parseInt(attachment.createdDateTime, 10) *
                                1000
                              ).toLocaleDateString(language || "en-US", {
                                weekday: "long",
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })
                              : ""}
                          </span>
                        </div>
                      </div>
                      <CgCloseO
                        size={16}
                        className="task-detail-modal-icon"
                        style={{ cursor: "pointer", marginLeft: "10px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setAttachmentToDelete(
                            attachment.attachmentId || attachment.id
                          );
                          setAttachmentTypeToDelete("task");
                          setIsAttachmentDeleteAlertOpen(true);
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

              <div className="task-detail-comments-container">
                <span
                  className="task-detail-modal-area-title"
                  style={{ marginBottom: "15px" }}
                >
                  {getTranslation("activity")}
                </span>
                {replyMention && (
                  <div className="reply-mention-container">
                    <span className="reply-mention-text">
                      {getTranslation("respondingTo")}:
                    </span>

                    <div className="reply-mention-bubble">
                      <span className="reply-mention-bubble-text">
                        {replyMention}
                      </span>
                      <CgCloseO
                        size={16}
                        className="reply-mention-bubble-cancel"
                        onClick={() => {
                          setReplyMention("");
                          setSelectedComment(null);
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="task-detail-comment-holder">
                  <input
                    ref={commentInputRef}
                    className="task-detail-modal-subtitle-input"
                    style={{ width: "100%" }}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder={getTranslation("writeAComment")}
                  />
                  <FiSend
                    onClick={handleSendComment}
                    className="task-comment-send-icon"
                    size={20}
                  />
                  <GrAttachment
                    onClick={() => commentFileInputRef.current.click()}
                    className="task-comment-send-icon"
                    size={20}
                  />
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg,.gif,.pdf,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip,.mp4,.mp3,.wav,.json,.csv,.dat"
                    ref={commentFileInputRef}
                    style={{ display: "none" }}
                    multiple
                    onChange={handleCommentFileChange}
                  />
                </div>
                {commentAttachments?.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      gap: "8px",
                      padding: "8px 0",
                      width: "100%",
                      marginBottom: 20,
                    }}
                  >
                    {commentAttachments.map((file, index) => (
                      <div
                        className="task-detail-modal-added-attachment-chip"
                        key={index}
                      >
                        <span className="task-detail-modal-added-attachment-chip-title">
                          {file.title}
                        </span>
                        <CgCloseO
                          onClick={() => removeCommentAttachment(index)}
                          style={{
                            cursor: "var(--pointer)",
                            minWidth: "14px",
                            minHeight: "14px",
                            width: "14px",
                            height: "14px",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {activities?.map((item) => {
                  if (item.type === "log") {
                    const createdBy = item.dataJson?.createdBy;
                    return (
                      <div
                        key={`log-${item.logId || item.id}`}
                        className="task-detail-comment-holder"
                      >
                        {createdBy.userAvatar ? (
                          <img
                            src={createdBy.userAvatar}
                            className="social-hive-chat__avatar"
                          />
                        ) : (
                          <div className="social-hive-chat__avatar">
                            {getFirstAndLastInitials(
                              createdBy.name + " " + createdBy.lastname
                            )}
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            marginTop: "-5px",
                          }}
                        >
                          <span style={{ width: "100%" }}>
                            <span className="task-detail-user-name">
                              {createdBy
                                ? `${createdBy.name} ${createdBy.lastname}`
                                : item.createdBy}
                            </span>
                            <span className="task-detail-comment-date">
                              {item.log}
                            </span>
                          </span>
                          <span className="task-detail-comment-date">
                            {formatDateTimeDisplay(item.date)}
                          </span>
                        </div>
                      </div>
                    );
                  } else if (item.type === "comment") {
                    return (
                      <div
                        key={`comment-${item.taskCommentId || item.id}`}
                        style={{ width: "100%" }}
                      >
                        <div className="task-detail-comment-holder">
                          {item.userAvatar ? (
                            <img
                              src={item.userAvatar}
                              className="social-hive-chat__avatar"
                            />
                          ) : (
                            <div className="social-hive-chat__avatar">
                              {getFirstAndLastInitials(
                                item.name + " " + item.lastname
                              )}
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              marginTop: "-5px",
                            }}
                          >
                            <span style={{ width: "100%" }}>
                              <span className="task-detail-user-name">
                                {item.name} {item.lastname}
                              </span>
                              <span className="task-detail-comment-date">
                                {formatDateTimeDisplay(item.date)}
                              </span>
                            </span>
                            {editingCommentId ===
                              (item.taskCommentId || item.id) ? (
                              <input
                                type="text"
                                className="task-detail-comment-box"
                                value={editingCommentText}
                                onChange={(e) =>
                                  setEditingCommentText(e.target.value)
                                }
                              />
                            ) : (
                              <span className="task-detail-comment-box">
                                {item.comment}
                              </span>
                            )}

                            {/* Eğer yorumun attachments varsa, onları göster */}
                            {item.attachments &&
                              item.attachments.length > 0 && (
                                <div className="task-detail-comment-attachments">
                                  {item.attachments.map((att, idx) => (
                                    <div
                                      key={att.attachmentId || idx}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        className="task-detail-attachment-holder"
                                        onClick={() =>
                                          window.open(att.attachment, "_blank")
                                        }
                                        style={{
                                          display: "flex",
                                          flex: 1,
                                          cursor: "var(--pointer)",
                                        }}
                                      >
                                        <div className="task-detail-attachment-box" />
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <span className="task-detail-attachment-title">
                                            {att.title}
                                          </span>
                                          <span className="task-detail-attachment-size">
                                            {att.createdDateTime
                                              ? new Date(
                                                parseInt(
                                                  att.createdDateTime,
                                                  10
                                                ) * 1000
                                              ).toLocaleDateString(
                                                language || "en-US",
                                                {
                                                  weekday: "long",
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                }
                                              )
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                      {item.createdBy === userId && (
                                        <CgCloseO
                                          size={16}
                                          className="task-detail-modal-icon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setAttachmentToDelete(
                                              att.attachmentId || att.id
                                            );
                                            setAttachmentTypeToDelete(
                                              "comment"
                                            );
                                            setIsAttachmentDeleteAlertOpen(
                                              true
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}

                            <div className="task-detail-comment-footer">
                              <span
                                onClick={() => {
                                  setSelectedComment(item.taskCommentId);
                                  setReplyMention(`@${item.name}`);
                                  commentInputRef.current.focus();
                                }}
                                className="task-detail-reply-button"
                              >
                                {getTranslation("reply")}
                              </span>
                              {item?.createdBy === userId && (
                                <>
                                  {editingCommentId ===
                                    (item.taskCommentId || item.id) ? (
                                    <span
                                      onClick={handleCommentUpdate}
                                      className="task-detail-reply-button"
                                    >
                                      {getTranslation("save")}
                                    </span>
                                  ) : (
                                    <span
                                      onClick={() => {
                                        setEditingCommentId(
                                          item.taskCommentId || item.id
                                        );
                                        setEditingCommentText(item.comment);
                                      }}
                                      className="task-detail-reply-button"
                                    >
                                      {getTranslation("edit")}
                                    </span>
                                  )}
                                  <span
                                    onClick={() => handleCommentDelete(item)}
                                    className="task-detail-reply-button"
                                  >
                                    {getTranslation("delete")}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {item.replies &&
                          item.replies.map((reply) => (
                            <div
                              key={`reply-${reply.taskCommentId || reply.id}`}
                              className="task-detail-comment-reply-holder"
                            >
                              {reply.userAvatar ? (
                                <img
                                  src={reply.userAvatar}
                                  className="social-hive-chat__avatar"
                                />
                              ) : (
                                <div className="social-hive-chat__avatar">
                                  {getFirstAndLastInitials(
                                    reply.name + " " + reply.lastname
                                  )}
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                  alignItems: "flex-start",
                                  justifyContent: "flex-start",
                                  marginTop: "-5px",
                                }}
                              >
                                <span style={{ width: "100%" }}>
                                  <span className="task-detail-user-name">
                                    {reply.name} {reply.lastname}
                                  </span>
                                  <span className="task-detail-comment-date">
                                    {formatDateTimeDisplay(
                                      parseInt(reply.createdDateTime, 10) * 1000
                                    )}
                                  </span>
                                </span>
                                {editingCommentId ===
                                  (reply.taskCommentId || reply.id) ? (
                                  <input
                                    type="text"
                                    className="task-detail-comment-box"
                                    value={editingCommentText}
                                    onChange={(e) =>
                                      setEditingCommentText(e.target.value)
                                    }
                                  />
                                ) : (
                                  <span className="task-detail-comment-box">
                                    {reply.comment}
                                  </span>
                                )}

                                {/* Reply attachments */}
                                {reply.attachments &&
                                  reply.attachments.length > 0 && (
                                    <div className="task-detail-comment-attachments">
                                      {reply.attachments.map((att, idx) => (
                                        <div
                                          key={att.attachmentId || idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            className="task-detail-attachment-holder"
                                            onClick={() =>
                                              window.open(
                                                att.attachment,
                                                "_blank"
                                              )
                                            }
                                            style={{
                                              display: "flex",
                                              flex: 1,
                                              cursor: "var(--pointer)",
                                            }}
                                          >
                                            <div className="task-detail-attachment-box" />
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <span className="task-detail-attachment-title">
                                                {att.title}
                                              </span>
                                              <span className="task-detail-attachment-size">
                                                {att.createdDateTime
                                                  ? new Date(
                                                    parseInt(
                                                      att.createdDateTime,
                                                      10
                                                    ) * 1000
                                                  ).toLocaleDateString(
                                                    language || "en-US",
                                                    {
                                                      weekday: "long",
                                                      day: "numeric",
                                                      month: "short",
                                                      year: "numeric",
                                                    }
                                                  )
                                                  : ""}
                                              </span>
                                            </div>
                                          </div>
                                          {reply.createdBy === userId && (
                                            <CgCloseO
                                              size={16}
                                              className="task-detail-modal-icon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setAttachmentToDelete(
                                                  att.attachmentId || att.id
                                                );
                                                setAttachmentTypeToDelete(
                                                  "comment"
                                                );
                                                setIsAttachmentDeleteAlertOpen(
                                                  true
                                                );
                                              }}
                                            />
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                <div className="task-detail-comment-footer">
                                  <span
                                    onClick={() => {
                                      setSelectedComment(item.taskCommentId);
                                      setReplyMention(`@${reply.name}`);
                                      commentInputRef.current.focus();
                                    }}
                                    className="task-detail-reply-button"
                                  >
                                    {getTranslation("reply")}
                                  </span>
                                  {reply?.createdBy === userId && (
                                    <>
                                      {editingCommentId ===
                                        (reply.taskCommentId || reply.id) ? (
                                        <span
                                          onClick={handleCommentUpdate}
                                          className="task-detail-reply-button"
                                        >
                                          {getTranslation("save")}
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() => {
                                            setEditingCommentId(
                                              reply.taskCommentId || reply.id
                                            );
                                            setEditingCommentText(
                                              reply.comment
                                            );
                                          }}
                                          className="task-detail-reply-button"
                                        >
                                          {getTranslation("edit")}
                                        </span>
                                      )}
                                      <span
                                        onClick={() =>
                                          handleCommentDelete(reply)
                                        }
                                        className="task-detail-reply-button"
                                      >
                                        {getTranslation("delete")}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>

            <div style={{ width: "30%" }}>
              <div
                className="task-detail-modal-description"
                style={{
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: "100%",
                  display: "flex",
                }}
              >
                <span className="task-detail-modal-area-title">
                  {getTranslation("myCollaborators")}
                </span>

                <span style={{ width: "100%" }}>
                  <TaskMemberDropdown
                    users={users}
                    task={_task}
                    inTaskUsers={
                      _task?.members
                        ? _task?.members?.map((user) => ({
                          ...user,
                          userID: user.id,
                        }))
                        : []
                    }
                  />
                </span>
              </div>

              <div className="task-detail-modal-todo-container">
                <span className="task-detail-modal-area-title">
                  {getTranslation("toDoList")}
                </span>
                {!inputVisible ? (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      setInputVisible(true);
                      setTempTodoList([...todoList]);
                    }}
                  >
                    <TbEdit className="task-detail-modal-icon" size={18} />
                  </span>
                ) : (
                  <span onClick={handleSaveTodoList}>
                    <TbDeviceFloppy
                      className="task-detail-modal-icon"
                      size={18}
                    />
                  </span>
                )}
              </div>
              {inputVisible && (
                <>
                  <div className="task-detail-todo-input-container">
                    <input
                      type="text"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder={getTranslation("enterToDo")}
                      className="task-detail-todo-input"
                    />
                    <button
                      className="task-detail-todo-add-button"
                      onClick={handleAddTodo}
                    >
                      {getTranslation("add")}
                    </button>
                  </div>
                  {tempTodoList?.map((item, index) => (
                    <div key={index} className="task-detail-todo-box">
                      <input
                        type="text"
                        className="task-detail-todo-input"
                        value={item.text}
                        onChange={(e) => updateTempTodo(index, e.target.value)}
                        style={{
                          width: "85%",
                          border: "none",
                          backgroundColor: "transparent",
                          color: "inherit",
                        }}
                      />
                      <LiaTrashAltSolid
                        size={23}
                        onClick={() => handleRemoveTempTodo(item)}
                        style={{ cursor: "var(--pointer)" }}
                      />
                    </div>
                  ))}
                </>
              )}
              {!inputVisible &&
                todoList?.map((item, index) => (
                  <div
                    key={index}
                    className="task-detail-todo-box"
                    style={{ justifyContent: "flex-start", gap: "15px" }}
                    onClick={() => toggleCheckbox(item)}
                  >
                    <input type="checkbox" checked={item.checked} />
                    <span>{item.text}</span>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}

      <AlertBox
        isOpen={isAlertOpen}
        message={getTranslation("activeKronosMessage", {
          projectTitle: activeKronos?.projectTitle,
          kronosTitle: activeKronos?.title,
        })}
        buttons={buttons}
        type={"warning"}
      />

      <AlertBox
        isOpen={isDeleteAlertOpen}
        title={getTranslation("areYouSure")}
        message={getTranslation("taskDeleteWarning")}
        onConfirm={deleteTask}
        onCancel={() => setIsDeleteAlertOpen(false)}
        confirmText={getTranslation("yes")}
        cancelText={getTranslation("no")}
        type={"warning"}
      />

      <AlertBox
        isOpen={isAttachmentDeleteAlertOpen}
        title={getTranslation("areYouSure")}
        message={
          getTranslation("Do you want to delete this document?") ||
          "Do you want to delete this document?"
        }
        onConfirm={() => {
          handleAttachmentDelete(attachmentToDelete);
          setIsAttachmentDeleteAlertOpen(false);
          setAttachmentToDelete(null);
        }}
        onCancel={() => setIsAttachmentDeleteAlertOpen(false)}
        confirmText={getTranslation("yes")}
        cancelText={getTranslation("no")}
        type={"warning"}
      />
    </div>
  );
}
